import React, { useEffect } from "react";
/* Components */
import ShaiaBot from "../components/shaiaBot/shaiabot";
import SignInForm from "../components/form/signIn";
import { useNavigate } from "react-router-dom";
import { useMixPanel } from "../hooks/useMixPanel";
import { useTranslation } from "react-i18next";
import useUserStore from "../store/useUser.store";
import { MIX_PANEL_EVENTS } from "../utils/constans";
import ToggleSwitch from "../components/form-elements/ToggleSwitch/toggleSwitch";
import SidebarIndex from "../components/sidebar/SidebarIndex";
/* Assets */
import logoShaia from "../assets/azul-alt.svg";

const LoginPage = () => {
  const navigate = useNavigate();
  const { sendEvent } = useMixPanel();
  const { t, i18n } = useTranslation();
  const { setLang } = useUserStore();
  useEffect(() => {
    sendEvent(MIX_PANEL_EVENTS.loginView);

    localStorage.clear();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSwitch = (event) => {
    i18n.changeLanguage(event ? "en" : "es");
    setLang(event ? "en" : "es");
    localStorage.setItem("lang", event ? "en" : "es");
  };

  return (
    <div className="relative flex h-screen w-full flex-row">
      <SidebarIndex />
      <div className="login-wrapper light-theme">
        <div className="md-max:mt-2 md-max:pb-4 md-max:justify-between flex w-full flex-row items-center justify-end pl-4 pr-9 md:absolute md:right-0 md:top-4">
          <img src={logoShaia} className="max-w-20 md:hidden" alt="Shaia" />
          <ToggleSwitch name="lang" onChange={onSwitch} />
        </div>
        <ShaiaBot />
        <SignInForm />
        <p className="user-account-link">
          😱 {t("notHaveAccount")}.{" "}
          <button onClick={() => navigate("/register")}>
            {t("createAccount")}
          </button>
        </p>
        <p className="user-recovery-link">
          😵‍💫 {t("olvide_mi_contrasena")}{" "}
          <button onClick={() => navigate("/recovery-password")}>
            {t("restablecer_contrasena")}
          </button>
        </p>
        <div className="sm-max:w-full sm-max:flex-col absolute bottom-4 left-1/2 flex w-full -translate-x-1/2 flex-row items-center justify-center gap-1">
          <p className="user-recovery-link m-0 flex w-auto flex-1 items-center justify-center gap-4">
            <button
              onClick={() =>
                window.open(
                  "https://mentu.co/tratamiento-de-datos",
                  "_blank",
                  "noopener,noreferrer",
                )
              }
            >
              Tratamiento de Datos
            </button>
          </p>
          <p className="user-recovery-link m-0 flex w-auto flex-1 items-center justify-center gap-4">
            <button
              onClick={() =>
                window.open(
                  "https://mentu.co/autorizacion-de-tratamiento-de-datos",
                  "_blank",
                  "noopener,noreferrer",
                )
              }
            >
              Autorizacion de Tratamiento de Datos
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
